/**
 * Auth URL parameter names shared by all login entry points.
 * Keeping them in one place prevents each page from parsing a slightly different flow.
 */
const AUTH_PARAM_NAMES = {
  sso: "sso",
  user: "user",
  session: "session",
  iv: "iv",
  code: "code",
  state: "state",
} as const;

export interface AuthParamsSnapshot {
  sso: string;
  userParam: string;
  sessionParam: string;
  ivParam: string;
  code: string;
  state: string;
  hasSsoRequest: boolean;
  hasTpassCallback: boolean;
  hasOidcCallback: boolean;
  hasAnyAuthParam: boolean;
}

export const parseAuthParams = (search: string | URLSearchParams): AuthParamsSnapshot => {
  const params = typeof search === "string" ? new URLSearchParams(search) : search;
  const sso = params.get(AUTH_PARAM_NAMES.sso) ?? "";
  const userParam = params.get(AUTH_PARAM_NAMES.user) ?? "";
  const sessionParam = params.get(AUTH_PARAM_NAMES.session) ?? "";
  const ivParam = params.get(AUTH_PARAM_NAMES.iv) ?? "";
  const code = params.get(AUTH_PARAM_NAMES.code) ?? "";
  const state = params.get(AUTH_PARAM_NAMES.state) ?? "";
  const hasSsoRequest = sso === "true";
  const hasTpassCallback = Boolean(userParam && sessionParam && ivParam);
  const hasOidcCallback = Boolean(code && state);

  return {
    sso,
    userParam,
    sessionParam,
    ivParam,
    code,
    state,
    hasSsoRequest,
    hasTpassCallback,
    hasOidcCallback,
    hasAnyAuthParam: hasSsoRequest || hasTpassCallback || hasOidcCallback,
  };
};

export const readAuthParamsFromLocation = () => parseAuthParams(window.location.search);

export const cleanAuthUrl = () => {
  const cleanUrl = window.location.origin + window.location.pathname;
  window.history.replaceState({}, document.title, cleanUrl);
};
